import { Component, OnInit } from '@angular/core';
import { RouterLink, ActivatedRoute }  from '@angular/router';

@Component({
  selector: 'side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/ui/side-nav/side-nav.component.ts